export {}
declare const posthog: any;
import { getCreditUnionGroups } from './posthog-group'


/**
 * Infers the page context from the current URL pathname.
 */
function getPageContext(): string {
    const path = window.location.pathname.toLowerCase()
    if (path.includes('/dealers-details/')) {
        return 'dealer_detail'
    }
    if (path.startsWith('/dealers')) {
        return 'dealers_list'
    }
    if (path.includes('/details/')) {
        return 'vehicle_detail'
    }
    return 'unknown'
}

/**
 * Reads dealership ID from the closest ancestor with data-dealershipid.
 * Falls back to URL slug on legacy /dealers-details/ markup.
 */
function getDealershipId(linkEl: HTMLElement): string | undefined {
    const ancestor = linkEl.closest('[data-dealershipid]') as HTMLElement | null
    if (ancestor) {
        return ancestor.getAttribute('data-dealershipid') ?? undefined
    }

    // On /dealers-details/{slug} pages, extract slug from URL as fallback
    const dealerDetailMatch = window.location.pathname.match(/\/dealers-details\/([^/?]+)/i)
    if (dealerDetailMatch) {
        return dealerDetailMatch[1]
    }

    return undefined
}

/**
 * Reads dealership name from nearest data-dealershipname attribute.
 * Falls back to h1 text on legacy dealer detail markup.
 */
function getDealershipName(linkEl: HTMLElement): string | undefined {
    const ancestor = linkEl.closest('[data-dealershipname]') as HTMLElement | null
    if (ancestor) {
        return ancestor.getAttribute('data-dealershipname') ?? undefined
    }

    if (window.location.pathname.toLowerCase().includes('/dealers-details/')) {
        return document.querySelector('h1')?.textContent?.trim() ?? undefined
    }

    return undefined
}

function captureDealerPhoneClick(phoneEl: HTMLElement): void {
    if (typeof posthog === 'undefined') return

    const explicitContactType = phoneEl.getAttribute('data-contact-type')
    const phoneText = phoneEl.textContent?.toLowerCase() ?? ''
    const contactType = explicitContactType
        ?? (phoneText.includes('cell') ? 'cell' : phoneText.includes('work') ? 'work' : 'unknown')

    posthog.capture('dealer_phone_clicked', {
        dealership_id: getDealershipId(phoneEl),
        dealership_name: getDealershipName(phoneEl),
        contact_type: contactType,
        page_context: getPageContext(),
        $groups: getCreditUnionGroups(),
    })
}

// Desktop records the reveal action. Its revealed tel: link is excluded below so
// starting the call does not produce a duplicate analytics event.
document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return

    const revealButton = event.target.closest<HTMLElement>('[data-phone-reveal]')
    if (revealButton) {
        const container = revealButton.closest<HTMLElement>('[data-phone-reveal-container]')
        const phoneLink = container?.querySelector<HTMLElement>('[data-phone-reveal-link]')
        if (!phoneLink) return

        revealButton.classList.remove('md:inline-flex')
        revealButton.classList.add('hidden')
        phoneLink.classList.remove('hidden')
        phoneLink.focus({ preventScroll: true })
        captureDealerPhoneClick(revealButton)
        return
    }

    const phoneLink = event.target.closest<HTMLElement>('a[data-dealer-phone][href^="tel:"]')
    if (!phoneLink || phoneLink.hasAttribute('data-phone-reveal-link')) return

    captureDealerPhoneClick(phoneLink)
})
